/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import CurrencyInput, {
  countryOptions
} from 'components/wise-components/CurrencyInput';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CostBreakDownItem from 'components/wise-components/CostBreakDownItem';
import { Button, Dropdown, Offcanvas } from 'react-bootstrap';
import { thousandSeparator } from 'helpers/helper';
import WiseModalExchangeRate from '../wise-modals/WiseModalExchangeRate';
import Flex from 'components/common/Flex';
import WiseScheduleModal from 'components/wise-modals/WiseScheduleModal';
import ComparePriceModal from 'components/wise-modals/ComparePriceModal';
import { days, months } from 'data/month';
import { useNavigate } from 'react-router-dom';
import WiseAlert from 'components/wise-components/WiseAlert';
import TooltipComponent from 'components/wise-components/TooltipComponent';
import { routePaths } from 'routes/routePaths';

export const transferFee = [
  {
    title: 'Fast transfer',
    amount: 14.5,
    debitBy: 'Send money from your debit or credit card'
  },
  {
    title: 'Low cost transfer',
    amount: 8.07,
    debitBy: 'Send money from your bank account'
  },
  {
    title: 'Easy transfer',
    amount: 9.6,
    debitBy: 'Send from your bank with an online payment'
  }
];

function International() {
  const [selectedCurrency, setSelectedCurrency] = useState(countryOptions[100]);
  const [recipientCurrency, setRecipientCurrency] = useState(countryOptions[4]);
  const [transferType, setTransferType] = useState(transferFee[0]);

  const [show, setShow] = useState(false);
  const [showExchangeModal, setShowExchangeModal] = useState(false);
  const [lockState, setLockState] = useState(false);
  const [showContent, setShowContent] = useState('');
  const [showScheduledModal, setShowScheduledModal] = useState(false);
  const [scheduleDate, setScheduleDate] = useState({});
  const [showPriceCompareModal, setShowPriceCompareModal] = useState(false);

  let navigate = useNavigate();

  const handleClose = () => {
    setShow(false);

    setTimeout(() => {
      setShowContent('');
    }, 200);
  };

  const showHandler = contentToShow => {
    if (contentToShow) {
      setShow(true);
      setShowContent(contentToShow);
    }
  };

  const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
    <Button
      ref={ref}
      onClick={e => {
        e.preventDefault();
        onClick(e);
      }}
      variant="link"
      className="p-0 text-1000 text-decoration-underline fw-medium"
    >
      {children}

      <FontAwesomeIcon icon="angle-down" className="fs--1 ms-2" />
    </Button>
  ));

  const amountLockDeposit = () => (
    <p className="mb-0 p-2 text-start">
      An extra 42.06 EUR will be charged to guarantee the recipient receives the
      correct amount if the exchange rate fluctuates. Any left-over will be
      refunded.
      <a
        href="/help/articles/2448314/can-i-send-exact-amounts"
        target="_blank"
        className="ms-2 text-decoration-underline"
      >
        Learn more
      </a>
    </p>
  );
  const guaranteedRate = (title, text) => (
    <div className="text-start  p-2">
      <p className="mb-2 fs-0 fw-semi-bold">{title || 'Guaranteed rate'}</p>
      <p className="mb-0">
        {text ||
          'You’ll get this rate as long as we receive your 999.65 GBP within the next 2 hours.'}
        <a
          href="/help/articles/2448314/can-i-send-exact-amounts"
          target="_blank"
          className="ms-2 text-decoration-underline"
        >
          Learn more
        </a>
      </p>
    </div>
  );

  return (
    <>
      {false && (
        <WiseAlert
          text="You cannot create a scheduled transfer because you cannot send money
          from your Wise currency account. Please remove the schedule to
          continue."
        />
      )}
      <div>
        <CurrencyInput
          label="You send"
          selectedCurrency={selectedCurrency}
          setSelectedCurrency={setSelectedCurrency}
        />

        <CostBreakDownItem
          icon="minus"
          itemValue={
            <p className="mb-0 fw-semi-bold fs-0 text-1000 ms-3">
              {thousandSeparator(4.62)} {selectedCurrency.value}
            </p>
          }
          itemInfo={
            <>
              <Dropdown className="d-none d-md-block">
                <Dropdown.Toggle
                  as={CustomToggle}
                  id="dropdown-custom-components"
                >
                  {transferType?.title} fee
                </Dropdown.Toggle>

                <Dropdown.Menu className="c-dropdown">
                  <p className="mb-1 text-900 px-4">Transfer type</p>
                  {transferFee?.map((item, index) => (
                    <Dropdown.Item
                      key={index}
                      className="px-3"
                      onClick={() => setTransferType(item)}
                      as="button"
                    >
                      <div
                        className={`${
                          transferType?.title === item.title &&
                          'bg-primary text-white'
                        } hover-bg-primary align-items-center py-2 px-3 rounded-3`}
                      >
                        <p className="mb-1 fs-0">
                          {item.title} - {item.amount} {selectedCurrency.value}
                        </p>
                        <p className="mb-0 fs--1">{item.debitBy}</p>
                      </div>
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>

              <Button
                variant="link"
                className="p-0 text-1000 text-decoration-underline fw-medium d-md-none"
                onClick={() => showHandler('transfer-fee')}
              >
                {transferType?.title} fee
                <FontAwesomeIcon icon="angle-down" className="fs--1 ms-2" />
              </Button>
            </>
          }
        />

        <CostBreakDownItem
          icon="minus"
          itemValue={
            <p className="mb-0 fw-semi-bold fs-0 text-1000 ms-3">
              {thousandSeparator(42.62)} {selectedCurrency.value}
            </p>
          }
          itemInfo={
            <>
              <TooltipComponent
                text={amountLockDeposit()}
                style={{ position: 'fixed', width: '300px' }}
                btnText={
                  <Button
                    variant="link"
                    className="p-0 text-1000 text-decoration-underline fw-medium d-none d-md-block"
                  >
                    Amount lock deposit
                  </Button>
                }
              />

              <Button
                variant="link"
                className="p-0 text-1000 text-decoration-underline fw-medium d-md-none"
                onClick={() => showHandler('amount-lock-deposit')}
              >
                Amount lock deposit
              </Button>
            </>
          }
        />

        <CostBreakDownItem
          icon="equals"
          itemValue={
            <p className="mb-0 fw-semi-bold fs-0 text-1000 ms-3">
              {thousandSeparator(1359.84)} {selectedCurrency.value}
            </p>
          }
          itemInfo={
            <p className="mb-0" onClick={() => {}}>
              Total amount we’ll convert
            </p>
          }
        />

        <CostBreakDownItem
          className="mb-4"
          icon="times"
          itemValue={
            <Button
              variant="link"
              className="fw-semi-bold fs-0 text-1000 ms-3 p-0 text-1000 text-decoration-underline"
              onClick={() => setShowExchangeModal(true)}
            >
              1.15048 {selectedCurrency.value}
            </Button>
          }
          itemInfo={
            <>
              <TooltipComponent
                text={guaranteedRate()}
                style={{ position: 'fixed', width: '300px' }}
                btnText={
                  <Button
                    variant="link"
                    className="p-0 text-1000 text-decoration-underline fw-medium d-none d-md-block"
                  >
                    Guaranteed rate 2h
                  </Button>
                }
              />

              <Button
                variant="link"
                className="p-0 text-1000 text-decoration-underline fw-medium d-md-none"
                onClick={() => showHandler('guaranteed-rate')}
              >
                Guaranteed rate 2h
              </Button>
            </>
          }
        />

        <CurrencyInput
          label="Recipient gets"
          selectedCurrency={recipientCurrency}
          setSelectedCurrency={setRecipientCurrency}
          showLock
          lockState={lockState}
          setLockState={setLockState}
        />

        <p className="text-700 fs--1">
          You could save up to{' '}
          <span className="fw-semi-bold text-1000">21.94</span> GBP vs the
          average bank.{' '}
          <Button
            variant="link"
            className="p-0 text-decoration-underline text-900 fs--1"
            onClick={() => setShowPriceCompareModal(true)}
          >
            Compare price
          </Button>{' '}
          {Object.keys(scheduleDate).length ? (
            <Button
              variant="link"
              onClick={() => setShowScheduledModal(true)}
              className="d-block bg-transparent border-0 shadow-none mt-1 fs--1 p-0 fw-semi-bold text-1000 text-decoration-underline"
            >
              {`Sending on ${new Date(scheduleDate?.date).getDate()}  ${
                months[new Date(scheduleDate?.date).getMonth()]
              }`}
            </Button>
          ) : null}
          Should arrive
          <span className="fw-semi-bold text-1000 ms-1">
            {Object.keys(scheduleDate).length
              ? `by ${days[new Date(scheduleDate?.date).getDay()]}`
              : 'in 2 hours'}
          </span>
        </p>

        <Flex>
          <Button
            onClick={() => setShowScheduledModal(true)}
            className="bg-transparent border-600 shadow-none text-800 rounded-circle p-2 select-calendar-data-btn me-2"
          >
            <FontAwesomeIcon
              icon={
                Object.keys(scheduleDate).length
                  ? 'calendar-check'
                  : 'calendar-alt'
              }
              size="lg"
            />
          </Button>
          <Button
            variant="primary"
            className="flex-1 rounded-5"
            onClick={() => navigate(routePaths.CONTACT_EXISTING)}
          >
            Continue
          </Button>
        </Flex>
      </div>

      <Offcanvas
        show={show}
        placement={'bottom'}
        onHide={handleClose}
        className="c-offcanvas-style"
      >
        <div className="offcanvas-close-line" />

        <Offcanvas.Body className="mt-4">
          {showContent === 'transfer-fee' && (
            <div>
              <p className="mb-3 text-900 px-3">Transfer type</p>
              {transferFee?.map((item, index) => (
                <div
                  onClick={() => {
                    setTransferType(item);
                    handleClose();
                  }}
                  key={index}
                  className={`${
                    transferType?.title === item.title &&
                    'bg-primary text-white'
                  } hover-bg-primary align-items-center py-2 px-3 rounded-3`}
                >
                  <p className="mb-1 fs-0">
                    {item.title} - {item.amount} {selectedCurrency.value}
                  </p>
                  <p className="mb-0 fs--1">{item.debitBy}</p>
                </div>
              ))}
            </div>
          )}

          {showContent === 'amount-lock-deposit' && amountLockDeposit()}
          {showContent === 'guaranteed-rate' && guaranteedRate()}
        </Offcanvas.Body>
      </Offcanvas>
      <WiseModalExchangeRate
        show={showExchangeModal}
        handleClose={() => setShowExchangeModal(false)}
      />
      <WiseScheduleModal
        show={showScheduledModal}
        handleClose={() => setShowScheduledModal(false)}
        setScheduleDate={setScheduleDate}
      />
      <ComparePriceModal
        show={showPriceCompareModal}
        handleClose={() => setShowPriceCompareModal(false)}
      />
    </>
  );
}

export default International;
